// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-empty-state {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding: 16px;
}
:where(.vuetify-styles) .v-empty-state--start {
  align-items: flex-start;
}
:where(.vuetify-styles) .v-empty-state--center {
  align-items: center;
}
:where(.vuetify-styles) .v-empty-state--end {
  align-items: flex-end;
}

:where(.vuetify-styles) .v-empty-state__media {
  text-align: center;
  width: 100%;
}
:where(.vuetify-styles) .v-empty-state__media .v-icon {
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}

:where(.vuetify-styles) .v-empty-state__headline {
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  font-size: 3.75rem;
  font-weight: 300;
  line-height: 1;
  text-align: center;
  margin-bottom: 8px;
}
:where(.vuetify-styles) .v-empty-state--mobile .v-empty-state__headline {
  font-size: 2.125rem;
}

:where(.vuetify-styles) .v-empty-state__title {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 4px;
  text-align: center;
}

:where(.vuetify-styles) .v-empty-state__text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.425;
  padding: 0 16px;
  text-align: center;
}

:where(.vuetify-styles) .v-empty-state__content {
  padding: 24px 0;
}

:where(.vuetify-styles) .v-empty-state__actions {
  display: flex;
  gap: 8px;
  padding: 16px;
}

:where(.vuetify-styles) .v-empty-state__action-btn.v-btn {
  background-color: initial;
  color: initial;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VEmptyState/VEmptyState.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;EACxE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".v-empty-state {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 100%;\n  padding: 16px;\n}\n.v-empty-state--start {\n  align-items: flex-start;\n}\n.v-empty-state--center {\n  align-items: center;\n}\n.v-empty-state--end {\n  align-items: flex-end;\n}\n\n.v-empty-state__media {\n  text-align: center;\n  width: 100%;\n}\n.v-empty-state__media .v-icon {\n  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));\n}\n\n.v-empty-state__headline {\n  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));\n  font-size: 3.75rem;\n  font-weight: 300;\n  line-height: 1;\n  text-align: center;\n  margin-bottom: 8px;\n}\n.v-empty-state--mobile .v-empty-state__headline {\n  font-size: 2.125rem;\n}\n\n.v-empty-state__title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  line-height: 1.6;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.v-empty-state__text {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.425;\n  padding: 0 16px;\n  text-align: center;\n}\n\n.v-empty-state__content {\n  padding: 24px 0;\n}\n\n.v-empty-state__actions {\n  display: flex;\n  gap: 8px;\n  padding: 16px;\n}\n\n.v-empty-state__action-btn.v-btn {\n  background-color: initial;\n  color: initial;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
